/**
 * LocalStorageキーとか
 */
export const LSKEY_OPTIN = "opt-in";
export const LSKEY_POPUP = (id) => {
  return `popup_${id}`;
};
